import { render, staticRenderFns } from "./MetricsAdmin.vue?vue&type=template&id=6cb339ba"
import script from "./MetricsAdmin.vue?vue&type=script&lang=js"
export * from "./MetricsAdmin.vue?vue&type=script&lang=js"
import style0 from "./MetricsAdmin.vue?vue&type=style&index=0&id=6cb339ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports